// eslint-disable-next-line @typescript-eslint/no-var-requires
Log = require("./utilities/LogUtility").Log;

// eslint-disable-next-line @typescript-eslint/no-var-requires
webViewFiles = require("@core/WebViewFiles").webViewFiles;

// eslint-disable-next-line @typescript-eslint/no-var-requires
isImplementedExtention = false;
